<nav *ngIf="pageData">
    <div class="body">
        <li class="item" *ngFor="let menuItem of pageData">
            <a [href]="menuItem.url">{{ menuItem.name }}</a>
        </li>
    </div>
</nav>
